import React from "react";
import { IconProps } from "./types";

function IconSortable(props: IconProps) {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="icon">
        <path
          id="Vector"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.63926 2.65063C7.8401 2.44979 8.16573 2.44979 8.36657 2.65063L11.7951 6.0792C11.996 6.28004 11.996 6.60567 11.7951 6.80651C11.5943 7.00735 11.2687 7.00735 11.0678 6.80651L8.00292 3.7416L4.938 6.80651C4.73716 7.00735 4.41153 7.00735 4.21069 6.80651C4.00985 6.60567 4.00985 6.28004 4.21069 6.0792L7.63926 2.65063ZM4.21069 10.1935C4.41153 9.99265 4.73716 9.99265 4.938 10.1935L8.00292 13.2584L11.0678 10.1935C11.2687 9.99265 11.5943 9.99265 11.7951 10.1935C11.996 10.3943 11.996 10.72 11.7951 10.9208L8.36657 14.3494C8.16573 14.5502 7.8401 14.5502 7.63926 14.3494L4.21069 10.9208C4.00985 10.72 4.00985 10.3943 4.21069 10.1935Z"
          fill="#64748B"
        />
      </g>
    </svg>
  );
}

export default IconSortable;
